module.exports = __webpack_public_path__ + "static/media/surCharge.55e5474e.svg";